import { useRef, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { changePhoto } from "../../../components/Usuario/api-usuario";
import { setUsuario } from "../../../components/Usuario/actions/actions";
import { perfilText } from "../../../components/Usuario/Perfil";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import { success } from "../../../util/ToastUtil";

const UsuarioMenu = ({ onLogout }) => {
  const usuario = useSelector((state) => state.usuario);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const hiddenFileInput = useRef(null);
  const foto = usuario?.fileName ? usuario.fotoUrl : undefined;

  const handleClose = () => setAnchorEl(null);

  const handleChangeImage = (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;

    const fileFormData = new FormData();
    fileFormData.append("file", file);
    changePhoto(usuario.id, fileFormData).then((data) => {
      if (!data) return;
      if (data.error) {
        errorMessage(data.message);
        return;
      }
      dispatch(setUsuario(data));
      success("Foto alterada.");
    });
  };

  return (
    <>
      <Tooltip title="Minha conta">
        <IconButton onClick={(event) => setAnchorEl(event.currentTarget)} className="no-print" sx={{ p: 0.5 }}>
          <Avatar src={foto} alt={usuario?.nome} sx={{ width: 38, height: 38, border: 2, borderColor: "common.white" }} />
        </IconButton>
      </Tooltip>
      <input type="file" accept=".jpg,.jpeg,.png" hidden ref={hiddenFileInput} onChange={handleChangeImage} />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { sx: { minWidth: 260, mt: 1 } } }}
      >
        <Box display="flex" alignItems="center" gap={1.5} px={2} py={1.5}>
          <Avatar src={foto} alt={usuario?.nome} sx={{ width: 48, height: 48 }} />
          <Box minWidth={0}>
            <Typography variant="subtitle2" noWrap>
              {usuario?.nome}
            </Typography>
            <Typography variant="caption" color="text.secondary" component="div" noWrap>
              {usuario?.email}
            </Typography>
            {usuario?.perfil && (
              <Typography variant="caption" color="text.secondary">
                {perfilText(usuario.perfil)}
              </Typography>
            )}
          </Box>
        </Box>
        <Divider />
        <MenuItem
          onClick={() => {
            handleClose();
            hiddenFileInput.current.click();
          }}
        >
          <ListItemIcon>
            <PhotoCameraOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Alterar foto
        </MenuItem>
        <MenuItem component={Link} to="/usuario-senha" state={{ usuario }} onClick={handleClose}>
          <ListItemIcon>
            <LockOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Trocar senha
        </MenuItem>
        <MenuItem component={Link} to="/configuracao" onClick={handleClose}>
          <ListItemIcon>
            <SettingsOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Configurações
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            handleClose();
            onLogout();
          }}
        >
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          Sair
        </MenuItem>
      </Menu>
    </>
  );
};

export default UsuarioMenu;
